import React from 'react';
import { Home, Compass, Coffee, Heart, User, ScanLine } from 'lucide-react';
import { ScreenName } from '../types';
interface BottomNavProps {
  currentScreen: ScreenName;
  onNavigate: (screen: ScreenName) => void;
}
export function BottomNav({
  currentScreen,
  onNavigate
}: BottomNavProps) {
  const leftTabs = [{
    id: 'home',
    icon: Home,
    label: 'Home'
  }, {
    id: 'explore',
    icon: Compass,
    label: 'Explore'
  }];
  const TreatsIcon = ({
    size,
    className
  }: {
    size: number;
    className: string;
  }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-34">
      {/* Rounded Cup Body */}
      <path d="M18 8H6c-1.1 0-2 .9-2 2v5c0 3.3 2.7 6 6 6h4c3.3 0 6-2.7 6-6v-5c0-1.1-.9-2-2-2z" data-id="element-35" />
      {/* Circular Handle */}
      <path d="M18 11c1.7 0 3 1.3 3 3s-1.3 3-3 3" data-id="element-36" />
      {/* Heart on the cup - filled */}
      <path d="M12 13.5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1.4 1.4 1.4-1.4c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0" fill="currentColor" stroke="none" data-id="element-37" />
      {/* Curved Steam Lines */}
      <path d="M9 2c0 1.5 1 1.5 1 3" data-id="element-38" />
      <path d="M12 2c0 1.5 1 1.5 1 3" data-id="element-39" />
      <path d="M15 2c0 1.5 1 1.5 1 3" data-id="element-40" />
    </svg>;
  const rightTabs = [{
    id: 'gifting',
    icon: TreatsIcon,
    label: 'Treats'
  }, {
    id: 'profile',
    icon: User,
    label: 'Profile'
  }];
  // Determine active tab (handle nested screens)
  const getActiveTab = (screen: ScreenName) => {
    if (screen === 'storeProfile' || screen === 'menu' || screen === 'checkout' || screen === 'checkInSuccess') return 'explore';
    if (screen === 'giftRedeem' || screen === 'giftHistory') return 'gifting';
    if (screen === 'orders' || screen === 'orderDetails') return 'profile';
    return screen;
  };
  const activeTab = getActiveTab(currentScreen);
  return <div className="fixed bottom-0 left-0 right-0 bg-black rounded-t-3xl shadow-lg px-2 py-2 flex justify-between items-end max-w-md mx-auto z-50" data-id="element-41">
      {/* Left Tabs */}
      <div className="flex justify-around flex-1" data-id="element-42">
        {leftTabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onNavigate(tab.id as ScreenName)} className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all ${isActive ? 'bg-[#FFFC00] text-black' : 'text-white'}`} data-id="element-43">
              <Icon size={20} className={isActive ? 'text-black' : 'text-white'} data-id="element-44" />
              <span className="text-xs mt-1 font-medium" data-id="element-45">{tab.label}</span>
            </button>;
      })}
      </div>

      {/* Center Scan Button */}
      <div className="relative -top-5 px-1" data-id="element-46">
        <button onClick={() => onNavigate('scan')} className="w-14 h-14 bg-[#FFFC00] rounded-full flex items-center justify-center shadow-xl border-4 border-black active:scale-95 transition-transform" data-id="element-47">
          <ScanLine size={28} className="text-black" data-id="element-48" />
        </button>
      </div>

      {/* Right Tabs */}
      <div className="flex justify-around flex-1" data-id="element-49">
        {rightTabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onNavigate(tab.id as ScreenName)} className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all ${isActive ? 'bg-[#FFFC00] text-black' : 'text-white'}`} data-id="element-50">
              <Icon size={20} className={isActive ? 'text-black' : 'text-white'} data-id="element-51" />
              <span className="text-xs mt-1 font-medium" data-id="element-52">{tab.label}</span>
            </button>;
      })}
      </div>
    </div>;
}